"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectButton = exports.default = exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _nuiWidgets = require("@concur/nui-widgets");

var _reactLoader = _interopRequireDefault(require("react-loader"));

var _AutoConnectInput = _interopRequireDefault(require("./AutoConnectInput"));

var _listingModule = require("./listingModule");

var termsModule = _interopRequireWildcard(require("../terms/termsModule"));

var analyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));

var _trackClick = require("../HOCs/trackClick");

var _config = _interopRequireDefault(require("../config"));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listingDetails.css") : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/connectButton.css") : void 0;

var _analytics = require("../constants/analytics");

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = 1;
exports.COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE = COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
var SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = 2;
exports.SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE = SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;

var ConnectButton = function ConnectButton(_ref) {
  var listing = _ref.listing,
      inquire = _ref.inquire,
      userId = _ref.userId,
      isDisabled = _ref.isDisabled,
      launchTaCModal = _ref.launchTaCModal,
      launchModal = _ref.launchModal,
      modalNames = _ref.modalNames,
      connectToListing = _ref.connectToListing,
      terms = _ref.terms,
      isConnecting = _ref.isConnecting,
      trackLinkClick = _ref.trackLinkClick,
      trackButtonClick = _ref.trackButtonClick,
      companyUUID = _ref.companyUUID,
      _ref$userProfile = _ref.userProfile,
      userProfile = _ref$userProfile === void 0 ? {} : _ref$userProfile,
      trackInteractionEvent = _ref.trackInteractionEvent;
  var ID = listing.ID,
      _listing$core = listing.core,
      flow = _listing$core.oAuthWorkflowType,
      isUserConnected = _listing$core.isUserConnected,
      supportNewEnrollment = _listing$core.supportNewEnrollment,
      isConnectionPending = _listing$core.isConnectionPending,
      listingName = _listing$core.listingName,
      listingType = _listing$core.listingType,
      triplinkLoyaltyNumber = _listing$core.triplinkLoyaltyNumber,
      clientOptInType = _listing$core.clientOptInType,
      canUserConnect = _listing$core.canUserConnect,
      v1ID = _listing$core.v1ID,
      _listing$localized = listing.localized,
      connectURL = _listing$localized.connectURL,
      inquireURL = _listing$localized.inquireURL;
  var CON_REQ_FLOW = 'CONREQFLOW';
  var AUTO_CON_FLOW = 'AUTOCONFLOW';
  var ADMIN = 'ADMIN';
  var btnStyle = {
    width: '98%',
    minWidth: '150px',
    marginTop: '16px'
  };
  var spinnerOpts = {
    lines: 8,
    length: 0,
    width: 5,
    radius: 6,
    scale: 0.8,
    corners: 1,
    color: '#2379BF',
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    shadow: false,
    top: '50%',
    left: '50%',
    position: 'relative',
    padding: '10px',
    hwaccel: false,
    height: '20px'
  };

  function isCompanyAdminOrWSAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === COMPANY_ADMIN_OR_WEB_SERVICE_ADMIN_ROLE;
  }

  function isSystemAdminOrConcurAdmin() {
    var role = userProfile && userProfile.profile && userProfile.profile.Role;
    return role === SYSTEM_ADMIN_OR_CONCUR_ADMIN_ROLE;
  }

  function canConnectToEnterpriseApp() {
    return isCompanyAdminOrWSAdmin() || isSystemAdminOrConcurAdmin();
  }

  function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        v2_listing_id: ID,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  }

  function handleLaunchTaC(options) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.connect],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    launchTaCModal(_objectSpread({
      tAndCLinkClicked: false,
      flow: flow,
      listingId: listing.ID,
      v1ListingId: v1ID,
      needAnAccountClicked: false
    }, options));
  }

  function connectBtn(btnDisabled) {
    var formatConnect = btnDisabled ? _react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    })) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    });
    return canUserConnect && trackClicked(_react.default.createElement("button", {
      id: "listing-appcenter-flow-connect-button",
      className: "btn btn-default btn-lg ".concat(isDisabled ? 'disabled' : ''),
      onClick: handleLaunchTaC,
      style: btnStyle,
      disabled: btnDisabled || (flow === AUTO_CON_FLOW && !listing.loyaltyNumber || isConnecting) && !triplinkLoyaltyNumber
    }, isConnecting ? _react.default.createElement(_reactLoader.default, {
      loaded: !isConnecting,
      options: spinnerOpts,
      className: "connect-loader"
    }) : formatConnect), {
      value: 'CONNECT',
      type: 'BUTTON'
    });
  }

  function disconnectBtn() {
    var launchDisconnectModal = function launchDisconnectModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.disconnect],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.disconnect);
    }; // this removes the ability to disconnect from mobile


    if (connectURL && connectURL.indexOf('profile/profile_mobile.asp') !== -1) {
      return null;
    }

    return (clientOptInType === 'USER' || canConnectToEnterpriseApp()) && trackClicked(_react.default.createElement("button", {
      className: "btn btn-lg btn-default",
      onClick: launchDisconnectModal,
      style: btnStyle
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Disconnect"
    })), {
      value: 'DISCONNECT',
      type: 'BUTTON'
    });
  }

  function connectOrDisconnectBtn(btnDisabled) {
    return !isUserConnected ? connectBtn(btnDisabled) : disconnectBtn();
  }

  function handleInquireClicked(elementType) {
    trackInteractionEvent({
      elementType: elementType,
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.ReqInfo],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    window.open(inquireURL, 'Inquire');
    return inquire(listing.ID, userId);
  }

  var renderConnectedCheck = function renderConnectedCheck() {
    return userId && isUserConnected && _react.default.createElement("span", null, _react.default.createElement("span", {
      className: "is-connected-check-details icon-check icon-size-md"
    }), _react.default.createElement("h4", {
      className: "connection-message"
    }, listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Enrolled"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connected"
    })));
  };

  function requestInfoBtnAndDescription() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };

    return _react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, !isUserConnected && _react.default.createElement("div", null, trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.button);
      }
    }, _react.default.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformation"
    }))), {
      value: 'REQUEST_INFORMATION',
      type: 'BUTTON'
    }), _react.default.createElement("br", null), _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformationDescription"
    }), connectURL && _react.default.createElement("div", null, _react.default.createElement("br", null), _react.default.createElement(_nuiWidgets.Button, {
      type: "link",
      muted: userId && !canConnectToEnterpriseApp() || isDisabled,
      disabled: userId && !canConnectToEnterpriseApp() || isDisabled,
      style: {
        padding: '0px',
        textAlign: 'left'
      },
      onClick: function onClick() {
        if (userId) {
          return handleLaunchTaC();
        }

        return deeplinkToListing();
      }
    }, userId ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Connect"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "LoginToConnect"
    })), _react.default.createElement("br", null), canConnectToEnterpriseApp() ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectBusinessApp"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "EndUserConnectBusinessApp"
    }))));
  }

  function requestInfoLinkAndDescription() {
    return _react.default.createElement("div", {
      style: {
        textAlign: 'left',
        paddingTop: '16px'
      }
    }, trackClicked(_react.default.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return handleInquireClicked(_analytics.elementList.link);
      }
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformation"
    })), {
      value: 'REQUEST_INFORMATION',
      type: 'LINK'
    }), _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "RequestInformationDescription"
    }));
  }

  function inquireBtn() {
    if (listingType === 'COCPAP') {
      if (canConnectToEnterpriseApp()) {
        return _react.default.createElement("div", {
          style: {
            textAlign: 'left'
          }
        }, !isUserConnected && _react.default.createElement("div", null, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ActivateBusinessApp"
        })), _react.default.createElement(_nuiIntl.FormattedMessage, {
          id: "ConnectBusinessApp"
        })), connectOrDisconnectBtn(), requestInfoLinkAndDescription());
      }

      return _react.default.createElement("div", {
        style: {
          textAlign: 'left'
        }
      }, connectOrDisconnectBtn(true), !isUserConnected && _react.default.createElement("div", null, _react.default.createElement("br", null), _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "EndUserConnectBusinessApp"
      })), requestInfoLinkAndDescription());
    }

    return requestInfoBtnAndDescription();
  }

  function enrollBtn() {
    var launchEnrollModal = function launchEnrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.enroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.enroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: launchEnrollModal,
      disabled: isConnecting
    }, isConnecting ? _react.default.createElement(_reactLoader.default, {
      loaded: !isConnecting,
      options: spinnerOpts,
      className: "connect-loader"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Enroll"
    })), {
      value: 'ENROLL',
      type: 'BUTTON'
    });
  }

  function unenrollBtn() {
    var launchUnenrollModal = function launchUnenrollModal() {
      trackButtonClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.unenroll],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      launchModal(modalNames.unenroll);
      (0, _listingModule.checkForConnection)(ID, v1ID);
    };

    return trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: launchUnenrollModal
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "Unenroll"
    })), {
      value: 'UNENROLL',
      type: 'BUTTON'
    });
  }

  function enrollOrUnenrollBtn() {
    return !isUserConnected ? enrollBtn() : unenrollBtn();
  }

  function loginToConnectBtn() {
    var deeplinkToListing = function deeplinkToListing() {
      window.location = "".concat(_config.default.CTEUrl, "?hpo=20&cte=").concat(listing.ID);
    };

    return _react.default.createElement("div", null, trackClicked(_react.default.createElement("button", {
      type: "button",
      className: "btn btn-lg btn-default",
      style: btnStyle,
      onClick: deeplinkToListing
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "LoginToConnect"
    })), {
      value: 'LOGIN_TO_CONNECT',
      type: 'BUTTON'
    }), inquireURL ? requestInfoLinkAndDescription() : null);
  }

  function showBtn() {
    if (userId) {
      if (isConnectionPending && !isUserConnected) {
        return;
      }

      if (clientOptInType === ADMIN) {
        return inquireBtn();
      }

      if (listingType === 'COCPAP') {
        return connectOrDisconnectBtn();
      }

      return enrollOrUnenrollBtn();
    }

    if (listingType === 'ADVISR') {
      return inquireBtn();
    }

    return loginToConnectBtn();
  }

  function showNeedAnAccountLink() {
    var launchTaC = function launchTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.launchTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      handleLaunchTaC({
        needAnAccountClicked: true
      });
    };

    var connectWithoutTaC = function connectWithoutTaC(e) {
      trackLinkClick({
        elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.connectLoyaltyNumber, _analytics.needAnAccountLink, _analytics.connectWithoutTAndC],
        dimensions: {
          listingId: ID,
          listingName: listingName,
          companyUUID: companyUUID
        }
      });
      e.preventDefault();
      connectToListing(ID, v1ID, {
        needAnAccountClicked: true
      });
    };

    var areTermsAccepted = function areTermsAccepted() {
      if (terms) {
        return terms.previouslyAccepted || terms.currentlyAccepted;
      }

      return false;
    };

    if (isConnectionPending || isUserConnected) {
      return null;
    }

    return !isDisabled && userId && supportNewEnrollment && !triplinkLoyaltyNumber && clientOptInType !== ADMIN && _react.default.createElement("p", {
      style: {
        textAlign: 'center',
        paddingBottom: '5px'
      }
    }, _react.default.createElement("a", {
      href: "#",
      onClick: areTermsAccepted() ? connectWithoutTaC : launchTaC
    }, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "NeedAnAccount"
    })));
  }

  var renderAutoConnectInput = function renderAutoConnectInput() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && !isConnectionPending && !isUserConnected && _react.default.createElement(_AutoConnectInput.default, {
      listing: listing,
      isDisabled: isDisabled
    });
  };

  var showConnectionPendingMessage = function showConnectionPendingMessage() {
    return userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW) && isConnectionPending && !isUserConnected && _react.default.createElement("div", {
      style: {
        textAlign: 'left'
      }
    }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectionPending"
    })), _react.default.createElement("br", null), _react.default.createElement("h4", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ConnectionPendingMessage"
    })));
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: userId && (flow === AUTO_CON_FLOW || flow === CON_REQ_FLOW || clientOptInType === ADMIN) ? 'loyalty-box' : '',
    style: {
      textAlign: 'center'
    }
  }, false && _react.default.createElement("span", {
    style: {
      color: 'red',
      fontSize: '30px'
    }
  }, userProfile.profile && userProfile.profile.LoginID), renderAutoConnectInput(), renderConnectedCheck(), showNeedAnAccountLink(), showConnectionPendingMessage(), showBtn()));
};

exports.ConnectButton = ConnectButton;
ConnectButton.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string,
    core: _propTypes.default.object,
    images: _propTypes.default.object,
    localized: _propTypes.default.object,
    loyaltyNumber: _propTypes.default.string,
    v1data: _propTypes.default.object
  }).isRequired,
  modalNames: _propTypes.default.shape({
    confirmation: _propTypes.default.string,
    disconnect: _propTypes.default.string,
    enroll: _propTypes.default.string,
    unenroll: _propTypes.default.string
  }).isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }).isRequired,
  userId: _propTypes.default.string,
  connectToListing: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  inquire: _propTypes.default.func.isRequired,
  launchTaCModal: _propTypes.default.func.isRequired,
  launchModal: _propTypes.default.func.isRequired,
  isDisabled: _propTypes.default.bool.isRequired,
  isConnecting: _propTypes.default.bool.isRequired,
  trackLinkClick: _propTypes.default.func,
  trackButtonClick: _propTypes.default.func,
  trackInteractionEvent: _propTypes.default.func,
  companyUUID: _propTypes.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isConnecting: state.listing.isConnecting,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    terms: state.terms,
    companyUUID: state.userPrefs.companyUUID,
    userProfile: state.userProfile
  };
};

var _default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  launchModal: _listingModule.toggleModal,
  inquire: _listingModule.inquireListing,
  connectToListing: _listingModule.connectListing,
  launchTaCModal: termsModule.launchTaCModal,
  checkForConnection: _listingModule.checkForConnection,
  unenrollListing: _listingModule.unenrollListing,
  disconnectListing: _listingModule.disconnectListing,
  trackLinkClick: analyticsModule.linkClickDispatch,
  trackButtonClick: analyticsModule.buttonClickDispatch,
  trackInteractionEvent: analyticsModule.interactionEventDispatch
})(ConnectButton));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ConnectButton.js
// module id = 261
// module chunks = 0